// extracted by mini-css-extract-plugin
export default {"plateBarcodeInput":"plateBarcodeInput-oD2Ft","message":"message-LhPK0"};